import { useRef, useEffect, useState, useCallback } from "react";
import useModalState from "./useModalState";
import { createNewPromise, noopPromise } from "../utils/promise";

const useModalController = () => {
  const promiseRef = useRef({});
  const showRef = useRef(noopPromise);
  const [open, show, hide] = useModalState(false);
  const [handlers, setHandlers] = useState({});
  const [modalAdditionalProps, setProps] = useState({});
  useEffect(() => {
    if (open) return;
    promiseRef.current = createNewPromise();

    showRef.current = () => {
      show();
      return promiseRef.current.promise;
    };

    setHandlers({
      onConfirm(result) {
        promiseRef.current.resolve({
          result
        });
        hide();
      },

      onClose(reason = null) {
        promiseRef.current.resolve({
          reason
        });
        hide();
      }

    });
  }, [open, hide, show]);
  const showPromised = useCallback(props => {
    setProps(props);
    return showRef.current();
  }, []);
  return [{
    open,
    onConfirm: handlers.onConfirm,
    onClose: handlers.onClose,
    ...modalAdditionalProps
  }, showPromised, hide];
};

export default useModalController;